/**
 * Bond Custody-Provider Enumerator.
 *
 * imported from
 * https://bitbucket.org/exporodev/exporo_trading_platform/src/master/application/Exporo/Trading/src/Datatypes/Enums/Bonds/CustodyType.php
 */

const CustodyTypesEnum = Object.assign({
  CLEARSTREAM: 'clearstream',
  ETHEREUM: 'ethereum',
});

Object.freeze(CustodyTypesEnum);

export default CustodyTypesEnum;



// WEBPACK FOOTER //
// ./src/enum/trades/CustodyTypes.js